import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, BookOpenIcon, GiftIcon, HeartIcon, SparklesIcon, ZapIcon } from 'lucide-react';
const courseDetails = [{
  icon: BookOpenIcon,
  label: '6 Tomos Profesionales'
}, {
  icon: GiftIcon,
  label: '5 Bonos Exclusivos'
}, {
  icon: SparklesIcon,
  label: '3 Bonos Premium'
}, {
  icon: BadgeCheckIcon,
  label: 'Certificado Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-paper px-4 pb-12 pt-6 md:pb-20 md:pt-10" data-id="element-117" data-mp="xanra6gm7tij">
      <div className="absolute inset-x-0 top-0 h-2 bg-clay" aria-hidden="true" data-id="element-118" data-mp="sb1chsl5257m" />
      <div className="absolute right-[-12rem] top-24 h-80 w-80 rounded-full bg-rose/35 blur-3xl" aria-hidden="true" data-id="element-119" data-mp="sd4bv386lap0" />
      <div className="absolute bottom-0 left-[-14rem] h-72 w-72 rounded-full bg-sage/30 blur-3xl" aria-hidden="true" data-id="element-120" data-mp="3d1a9nnfemhev" />

      <div className="relative mx-auto flex max-w-6xl flex-col items-center text-center" data-id="element-121" data-mp="3825xcnx6o3kb">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} className="max-w-4xl" data-id="element-122" data-mp="3j7zc59vbxccg">
          <div className="inline-flex items-center gap-2 rounded-full border border-clay/25 bg-white/75 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-clay-dark sm:px-4 sm:py-2 sm:text-[11px]" data-id="element-123" data-mp="39al8kaui8i1k">
            <HeartIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-124" data-mp="30hrfnam4xk58" />
            Formación integral en inteligencia emocional
          </div>
          <h1 className="mt-3 font-heading text-2xl font-semibold leading-[1.04] tracking-tight text-ink sm:text-4xl md:mt-4 md:text-5xl" data-id="element-125" data-mp="35a2hwk4cli0y">
            Reconstruí tu autoestima, aprendé a gestionar tus emociones y transformá la relación con vos mismo.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.14
      }} className="relative mt-5 w-full max-w-5xl pb-7 md:mt-6 md:pb-9" data-id="element-126" data-mp="2hjoytj3qqtii">
          <div className="absolute inset-x-0 top-0 bottom-7 rounded-[1.45rem] border border-clay/20 bg-white/55 md:bottom-9 md:rounded-[1.7rem]" aria-hidden="true" data-id="element-127" data-mp="natatlbzb2pg" />
          <img src="https://cdn.magicpatterns.com/uploads/2GPLyVAc8JVjF5uK3vyPoB/ChatGPT_Image_21_jul_2026,_21_39_41.png" alt="Método Reconstrucción Interior: colección de seis tomos profesionales y cinco bonos exclusivos" className="relative mx-auto max-h-[42vh] w-full rounded-[1.25rem] object-contain shadow-xl shadow-ink/20 md:max-h-[48vh] md:rounded-[1.5rem]" data-id="element-128" data-mp="i9vpx0zl3uk9" />
          <a href="#oferta" className="absolute bottom-0 left-1/2 inline-flex -translate-x-1/2 items-center justify-center whitespace-nowrap rounded-full bg-clay px-5 py-3 text-xs font-bold uppercase tracking-[0.05em] text-white shadow-lg shadow-ink/25 transition-colors hover:bg-clay-dark focus-visible:outline-none sm:px-7 sm:py-4 sm:text-sm" data-id="element-129" data-mp="x14ldqq64a5b">
            Quiero comenzar mi transformación
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.28
      }} className="mt-3 max-w-2xl" data-id="element-130" data-mp="21b647yr3r2n6">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-clay-dark sm:text-sm" data-id="element-131" data-mp="2b20tlbznaicu">
            Método Reconstrucción Interior™
          </p>
          <div className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-ink/75 sm:text-sm" data-id="element-132" data-mp="2ky42d0p05f8r">
            <span className="tracking-[0.14em] text-clay-dark" data-id="element-133" data-mp="2p1sabkhjqcuj">★★★★★</span>
            <span data-id="element-134" data-mp="2tztu67msqg72">4.9/5 · +800 alumnos de Argentina</span>
          </div>
          <p className="mt-2 text-xs text-ink/55" data-id="element-135" data-mp="umhdsbj22joc">Acceso inmediato luego de completar tu compra.</p>
        </motion.div>
      </div>

      <div className="relative mx-auto mt-8 grid max-w-6xl grid-cols-1 gap-px overflow-hidden rounded-2xl border border-clay/15 bg-clay/15 sm:grid-cols-2 lg:grid-cols-5" data-id="element-136" data-mp="zkrawrocbucl">
        {courseDetails.map(({
        icon: Icon,
        label
      }) => <div key={label} className="flex items-center justify-center gap-2 bg-white/75 px-3 py-4 text-center text-xs font-semibold text-ink/75" data-id="element-137" data-mp="3vh5owkrj9we2">
            <Icon className="h-4 w-4 shrink-0 text-clay-dark" aria-hidden="true" data-id="element-138" data-mp="9aqlm64mnqtu" />
            <span data-id="element-139" data-mp="3hqa8mnepgd0g">{label}</span>
          </div>)}
      </div>
    </section>;
}